import { SuggestedSearchResponse } from "@api-types/suggested-search";
import {
	getApplicationHeaders,
	getCurrentLanguage,
	httpClient,
	UserTypes,
} from "@utils";

export default class SearchApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/offer`;
	}

	static getRequestHeaders = (userType: UserTypes = UserTypes.PRIMARY) => {
		const appHeaders = getApplicationHeaders(userType);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		appHeaders["Accept" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async getSuggestedSearch(): Promise<SuggestedSearchResponse> {
		return httpClient.get(
			`${this.baseUrl}/suggested-search?language=${getCurrentLanguage()}`,
			this.getRequestHeaders(),
			{
				responseType: "json",
			}
		);
	}
}
